import { memo } from 'react';

import { Builder, withChildren } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { uiImages } from '@/react/components/content/registry/data';
import { DataAttributes } from '../../template-data/DataAttributes';

/**
 * Register the Wrapper component.
 */
const register = (): void => {
  const component = memo(dynamic(async () => import('./index')));
  const componentWithChildren = withChildren(component);

  Builder.registerComponent(componentWithChildren, {
    name: 'DataAttributeBlock',
    canHaveChildren: true,
    inputs: [
      {
        name: 'attributes',
        friendlyName: 'Data Attributes',
        helperText: 'The data attributes to add to the wrapper.',
        type: 'list',
        defaultValue: [],
        subFields: [
          {
            name: 'name',
            type: 'string',
            friendlyName: 'Attribute Name',
            enum: Object.values(DataAttributes).map((value) => {
              return { label: value.split('-').join(' ').toUpperCase(), value };
            }),
            defaultValue: DataAttributes.Test
          },
          {
            name: 'value',
            friendlyName: 'Attribute Value',
            type: 'string',
            helperText:
              'The value of the data attribute. Should be unique to the page.',
            regex: {
              pattern: '^[a-z0-9]+(-[a-z0-9]+)*$',
              options: 'g',
              message:
                'Please enter a valid attribute value. It should only contain lowercase letters, numbers, and hyphens.'
            }
          }
        ]
      }
    ],
    defaultChildren: [],
    image: uiImages.sectionImage
  });
};

export default register;
